import { transitionStatusMapping } from "../../internals/stateAttributesMapping.js";
import { popupStateMapping } from "../../utils/popupStateMapping.js";
import { nestedDialogOpen } from "../popup/DialogPopupDataAttributes.js";
const dialogStateAttributesMapping = {
  ...popupStateMapping,
  ...transitionStatusMapping,
  nestedDialogOpen(value) {
    return value ? {
      [nestedDialogOpen]: ""
    } : null;
  }
};
export {
  dialogStateAttributesMapping
};
//# sourceMappingURL=stateAttributesMapping.js.map
